import React, { useEffect, useState } from 'react';

/* EODHD serves company logos off a public path whose case is decided per ticker
 * with no rule behind it. Measured against the live host:
 *
 *   US/aapl.png   200      US/AAPL.png   404
 *   US/SGAMY.png  200      US/sgamy.png  404
 *   US/swk.png    200      US/SWK.png    404
 *   AS/AJAX.png   200      AS/ajax.png   404
 *
 * So both are tried in turn and a monogram catches the rest - ST/EG7,
 * XETRA/DMP and US/AKO-B have no logo in either case, and a broken image icon
 * in a card grid looks like a bug rather than a gap.
 *
 * The path is built from eodhd_symbol and never from geo. EG7 is a Stockholm
 * listing whose search market is the US, so geo would send us to the wrong
 * exchange directory for every company we poll outside its home country.
 */

const BASE = 'https://eodhd.com/img/logos';

const sourcesFor = (symbol) => {
  const [code, exchange] = String(symbol || '').split('.');
  if (!code || !exchange) return [];
  return [
    `${BASE}/${exchange}/${code.toUpperCase()}.png`,
    `${BASE}/${exchange}/${code.toLowerCase()}.png`,
  ];
};

const monogram = (name, ticker) => {
  const words = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return String(ticker || '?').slice(0, 2).toUpperCase();
};

export default function Logo({ symbol, name, ticker, size = 28 }) {
  const sources = sourcesFor(symbol);
  const [attempt, setAttempt] = useState(0);

  // A new company has to start the chain again, or a card that recycles the
  // element keeps the previous company's exhausted state and shows a monogram.
  useEffect(() => setAttempt(0), [symbol]);

  const src = sources[attempt];
  const box = { width: size, height: size };

  if (!src) {
    return (
      <span className="tw-logo is-mono" style={{ ...box, fontSize: size * 0.36 }}>
        {monogram(name, ticker)}
      </span>
    );
  }

  return (
    <img
      className="tw-logo"
      style={box}
      src={src}
      alt=""
      loading="lazy"
      onError={() => setAttempt((i) => i + 1)}
    />
  );
}
